<template>
  <div
    v-if="isLoading"
    v-bind="$attrs"
    class="tw-animate-pulse tw-bg-neutral-400"
    :class="sizeClasses"
  />
  <slot v-else />
</template>

<script setup>
defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  sizeClasses: {
    type: [String, Array],
    default: 'tw-w-full tw-h-2 tw-rounded',
  },
})
</script>

<script>
export default {
  name: 'SkeletonLoader',
  inheritAttrs: false,
}
</script>
